import React, { useState } from 'react';
import { Accordion, AccordionTheme, Divider } from 'wix-ui-tpa/cssVars';
import {
  SelectedProduct,
  SlotService,
  V3Product,
} from '../../../../../utils/state/types';
import { SelectedAddons } from './SelectedAddons';
import { SelectedRelatedProducts } from './SelectedRelatedProducts';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { classes } from './MoreDetails.st.css';
import { SingleSlotDetailsDataHook } from './dataHooks';
import Duration from '../../Duration/Duration';
import StaffMembers from '../../StaffMembers/StaffMembers';
import Location from '../../Location/Location';
import { FormNestedSlot } from '../../../../../types/formSelectedSlots';

export type MoreDetailsProps = {
  slotService: SlotService;
  slot: FormNestedSlot;
  isSingleService: boolean;
  selectedProductAddons?: SelectedProduct[];
  relatedProducts?: V3Product[];
};
export const MoreDetails: React.FC<MoreDetailsProps> = ({
  slotService,
  slot,
  isSingleService,
  selectedProductAddons,
  relatedProducts,
}) => {
  const { t } = useTranslation();
  const { service, resourceSelections } = slotService;
  const { addOnByGroup, selectedAddons } = slotService;
  const [isExpanded, setIsExpanded] = useState(false);

  const hasAddons =
    addOnByGroup && selectedAddons && Object.keys(selectedAddons).length > 0;
  const renderContent = () => {
    return (
      <>
        <Location location={service.location} />
        <StaffMembers
          service={service}
          resourceSelections={resourceSelections}
        />
        <Duration
          slotService={slotService}
          slot={slot}
          totalNumberOfSessions={service.totalNumberOfSessions}
          remainingNumberOfSessions={service.remainingNumberOfSessions}
        />
        {hasAddons && <SelectedAddons slotService={slotService} />}
        <SelectedRelatedProducts
          selectedProductAddons={selectedProductAddons}
          relatedProducts={relatedProducts}
          paymentDetails={slotService.paymentDetails}
        />
      </>
    );
  };
  return (
    <div data-hook={SingleSlotDetailsDataHook.MORE_DETAILS}>
      {isExpanded && renderContent()}
      <Accordion
        className={classes.accordion}
        data-hook={SingleSlotDetailsDataHook.MORE_DETAILS_ACCORDION}
        onItemClick={(_id: string, isItemExpanded: boolean) =>
          setIsExpanded(isItemExpanded)
        }
      >
        <Accordion.Item
          id="more-details-section"
          title={t(
            isExpanded
              ? 'app.bookings-form.bookings-details.less-details.title'
              : 'app.bookings-form.bookings-details.more-details',
          )}
          theme={AccordionTheme.Line}
        >
          {!isExpanded && renderContent()}
        </Accordion.Item>
      </Accordion>
      {isSingleService && <Divider className={classes.divider} />}
    </div>
  );
};
